import { render, staticRenderFns } from "./PackageChoiceScreen.vue?vue&type=template&id=1055abe3&scoped=true&"
import script from "./PackageChoiceScreen.vue?vue&type=script&lang=js&"
export * from "./PackageChoiceScreen.vue?vue&type=script&lang=js&"
import style0 from "./PackageChoiceScreen.vue?vue&type=style&index=0&id=1055abe3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1055abe3",
  null
  
)

export default component.exports